module.exports = __webpack_public_path__ + "0a8fe9149e5b19b329df2e9afd2f0734.svg";